import type { UpgradeRequirements, InfrastructureBundle, ResourceBundle } from '@/types/EntityTypes';
import type { GameState } from '@/types/GameState';
import { Entity } from './Entity';

export class InfrastructureEntity extends Entity {
  failureRate?: number;
  maxCount?: number;

  constructor(params: {
    id: string;
    name: string;
    description: string;
    cost: number;
    storage?: ResourceBundle;
    consumes?: ResourceBundle;
    produces?: ResourceBundle;
    progressionRequirements?: UpgradeRequirements;
    failureRate?: number;
    maxCount?: number;
  }) {
    super(params);
    this.failureRate = params.failureRate;
    this.maxCount = params.maxCount;
  }

  override getDisplayText(): string {
    return `Build ${this.name} ($${this.cost})`;
  }

  getFailureRateContribution(count: number): number {
    return count * (this.failureRate || 0);
  }

  applyDegradation(gameState: GameState, stateProperty: keyof GameState): void {
    (gameState[stateProperty] as number)--;
  }

  getDegradationMessage(): string {
    return `🔧 ${this.name} degraded due to lack of maintenance!`;
  }

  getStatePropertyName(): keyof InfrastructureBundle {
    return this.id as keyof InfrastructureBundle;
  }

  static getAvailableInfrastructure(infrastructure: InfrastructureEntity[], gameState: GameState): InfrastructureEntity[] {
    return infrastructure.filter(inf => inf.meetsNonPersonnelRequirements(gameState));
  }
}